export const META_IMAGE_DIMENSIONS: [number, number] = [1200, 1200];
